import React from "react";
import { styled } from "styled-components";
import { Button } from "antd";
import {
  EnvironmentOutlined,
  PhoneOutlined,
  FacebookOutlined,
} from "@ant-design/icons";

import { MainContainer, Text } from "../../helpers/StyledComponents";
import TitleHeader from "../../components/Common/TitleHeader";
import { MobileSize } from "../../constant";

const ContactUs = () => {
  const linkTo = (link) => {
    window.open(link, "_blank");
  };
  return (
    <>
      <MainContainer>
        <TitleHeader en="CONTACT US" th="ติดต่อเรา" center />
        <ContactCardContainer>
          <CardContainer>
            <Text
              fontSize="16"
              style={{ textAlign: "center", marginBottom: "15px" }}
            >
              <TopicCard>
                <EnvironmentOutlined style={{ marginRight: 7, fontSize: 40 }} />
                <strong>Address / ที่อยู่</strong>
              </TopicCard>
            </Text>
            <Text>
              <strong>Scripture Union Thailand</strong>
              <br /> 274 North Sathorn Road, Bangrak, Bangkok 10500
              <br />
              <strong>คริสตธรรมสัมพันธ์ประเทศไทย</strong>
              <br /> 274 ถนนสาทรเหนือ บางรัก กรุงเทพฯ 10500(ชั้น 4 อาคารหกชั้น
              คริสตจักรสาธร)
            </Text>
          </CardContainer>
          <CardContainer>
            <Text fontSize="16" style={{ textAlign: "center" }}>
              <TopicCard>
                <PhoneOutlined style={{ marginRight: 7, fontSize: 40 }} />
                <strong>Contact / ติดต่อ</strong>
              </TopicCard>
            </Text>
            <Text>
              <ul>
                <li>สำนักงาน : 02-236-5598, 096-910-8498</li>
                <li>โทรสาร : 02-236-5598</li>
                <li>081-837-9985 (ผป.บุหงา)</li>
                <li>089-124-5600 (คุณมาลาศรี)</li>
                <li>081-928-6938 (ผป.วิวัฒน์)</li>
                <li>081-814-4577 (คุณสุกัญญา)</li>
              </ul>
              <ButtonContainer>
                <Button
                  type="primary"
                  onClick={() =>
                    linkTo("https://www.facebook.com/suthailand2020/")
                  }
                >
                  <ButtonText>
                    <FacebookOutlined />
                    Facebook
                  </ButtonText>
                </Button>
                <Button
                  type="primary"
                  style={{ background: "#06C755" }}
                  onClick={() =>
                    linkTo("https://page.line.me/016zbmcy?openQrModal=true")
                  }
                >
                  <ButtonText>
                    <img
                      src="webImg/Line.png"
                      style={{ width: "20px" }}
                      alt="line"
                    />
                    @su-thailand
                  </ButtonText>
                </Button>
              </ButtonContainer>
            </Text>
          </CardContainer>
        </ContactCardContainer>
      </MainContainer>
    </>
  );
};

const ContactCardContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: auto;
  display: flex;
  justify-content: space-evenly;
  gap: 20px;

  @media (max-width: ${MobileSize}px) {
    padding: 10px;
    flex-direction: column;
  }
`;

const CardContainer = styled.div`
  background: white;
  border-radius: 40px;
  padding: 40px;
  width: 100%;
  max-width: 500px;
`;

const TopicCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ButtonText = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;

const ButtonContainer = styled.div`
  margin: 30px auto 0px auto;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;
export default ContactUs;
